import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { UIModel } from '../../../../models/core/ui/ui.model';
import { GlobalErrorHandler } from '../../../../services/error.handler';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-group-forbidden',
  templateUrl: './group-forbidden.component.html',
  styleUrls: ['./group-forbidden.component.scss']
})
export class GroupForbiddenComponent implements OnInit {

  /**
   * Gets or sets animation options for lottie.
   */
  public animationOptions: AnimationOptions = {
    path: UIModel.notFoundErrorAnimationUrl
  };

  /**
   * Gets or sets exception message.
   */
  public exceptionMessage: string | undefined;

  constructor(private router: Router) { }

  public ngOnInit(): void {
    // Reset error as user should be able to navigate back
    // with this error.
    GlobalErrorHandler.isFatalError = false;
    GlobalErrorHandler.fatalError = undefined;
  }

  /**
   * Navigates back to previous page.
   */
  public navigateToPrevious(): void {
    // Move back to 2 because first page is the one that was not found.
    this.router.navigate(['/']);
  }

}
